export const privacyPolicyDisabledPartners = ["pcc", "pcc_wound"];
